let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eempH")).then(() => parcelRequire('8GXI8'));